import { render, staticRenderFns } from "./TimeOutPopup.vue?vue&type=template&id=06bb34ff&scoped=true&"
import script from "./TimeOutPopup.vue?vue&type=script&lang=js&"
export * from "./TimeOutPopup.vue?vue&type=script&lang=js&"
import style0 from "./TimeOutPopup.vue?vue&type=style&index=0&id=06bb34ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb34ff",
  null
  
)

export default component.exports